import React from 'react';

import IzendaIntegrate from '../../helper/IzendaIntegrate';
import {Indicator} from '../../components/indicators/indicator';

let interval = null;
let dom = null;

class IzendaReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  componentDidMount() {
    interval = setInterval(() => {
      if (window.IzendaSynergy) {
        dom = IzendaIntegrate.RenderReportDesigner(this.hideLoading);

        clearInterval(interval);

      }
    }, 1000);
  }

  componentWillUnmount() {
    IzendaIntegrate.DestroyDom(dom);
  }

  hideLoading = () => {
    this.setState({ isLoading: false });
  }

  render() {
    return <div>
      {
        this.state.isLoading && <Indicator id='setting-loading' show={true} />
      }
      <div className='page-title clearfix'>
        <h2 className='pull-left'>New Report</h2>
      </div> <div className='izenda-container' id='izenda-root-report-designer' style={{height: 1000}} />
    </div>;
  }
}

export default IzendaReport;



// WEBPACK FOOTER //
// ./src/izenda/containers/new-report.js